import React, { useState } from "react";
import { uploadImage } from "./api/imageApi";

import Plane from "./picture/plane.png";
import Back from "./picture/back.png";
import ImgIcon from "./picture/img.png";
import DescIcon from "./picture/info.png";

// CSS
import "./addflow.css";

const AddFlow = ({ selectedImage, onCancel, onConfirm }) => {
  const [isDescriptionView, setIsDescriptionView] = useState(false); // Toggle between image and description
  const [imageTitle, setImageTitle] = useState(""); // Title of the image
  const [tempTitle, setTempTitle] = useState(""); // Temporary input for the title
  const [description, setDescription] = useState(""); // Description text
  const [loading, setLoading] = useState(false); // Show loading state

  console.log(selectedImage);

  const getImageSize = (file) => {
    const sizeInBytes = file.file.size;

    if (sizeInBytes < 1024) {
      return `${sizeInBytes} B`; // Bytes
    } else if (sizeInBytes < 1024 * 1024) {
      return `${(sizeInBytes / 1024).toFixed(2)} KB`; // Kilobytes
    } else {
      return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`; // Megabytes
    }
  };

  const handleTitleConfirm = () => {
    if (!tempTitle.trim()) {
      alert("Please enter a valid title!");
      return;
    }
    setImageTitle(tempTitle);
    setIsDescriptionView(true); // Switch to description view
  };

  const handleDescriptionConfirm = async () => {
    if (!description.trim()) {
      alert("Please enter a description!");
      return;
    }

    const formData = new FormData();
    formData.append("title", imageTitle);
    formData.append("description", description);
    formData.append("user_id", 1); // Replace with actual user ID logic
    formData.append("album_id", null); // Null if not added to an album
    formData.append("image", selectedImage.file);

    setLoading(true);

    try {
      const response = await uploadImage(formData); // Upload image
      onConfirm(response.image); // Pass the image data to the parent component
    } catch (error) {
      console.error("Image upload failed:", error);
      alert("Failed to upload image. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Helper to format the date to dd.mm.yyyy
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  return (
    <div className="add-flow-wrapper">
      {/* Top Section */}
      <div className="add-flow-top">
        {!isDescriptionView ? (
          <img src={selectedImage.preview} alt="Uploaded Preview" />
        ) : (
          <>
            <div className="title-entry1">
              <input
                type="text"
                placeholder={selectedImage.file.name}
                value={tempTitle} // Temporary value
                onChange={(e) => setTempTitle(e.target.value)}
              />
              <button onClick={handleTitleConfirm}>
                <img
                  onClick={handleDescriptionConfirm}
                  src={Plane}
                  alt="Confirm Title"
                />
              </button>
            </div>
            <textarea
              placeholder=""
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="description-textarea"
              rows={21}
            />
          </>
        )}
      </div>

      {/* Bottom Section */}
      <div className="add-flow-bot">
        {imageTitle ? (
          <div className="add-flow-bot-row1">
            {!isDescriptionView ? (
              <>
                <button
                  onClick={() => setIsDescriptionView(!isDescriptionView)}
                >
                  <img src={DescIcon} alt="Toggle Description" />
                </button>
                <div className="description-placeholder">
                  <h1>{imageTitle || "IMAGE TITLE"}</h1>
                </div>
              </>
            ) : (
              <>
                <button
                  onClick={() => setIsDescriptionView(!isDescriptionView)}
                >
                  <img src={ImgIcon} alt="Toggle Description" />
                </button>
                <div className="description-placeholder">
                  <h1>{imageTitle || "IMAGE TITLE"}</h1>
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="add-flow-bot-row1">
            <input
              type="text"
              placeholder={selectedImage.file.name}
              value={tempTitle}
              onChange={(e) => setTempTitle(e.target.value)}
            />
            <button onClick={handleTitleConfirm}>
              <img src={Plane} alt="Confirm Title" />
            </button>
          </div>
        )}

        <div className="add-flow-bot-row2">
          <div>
            <h2>{formatDate(new Date())}</h2>
            <h2 className="add-FEflow-size">{getImageSize(selectedImage)}</h2>
          </div>
          <button onClick={onCancel}>
            <img src={Back} alt="Cancel" />
          </button>
        </div>
      </div>

      {isDescriptionView && (
        <div className="add-flow-actions">
          <button
            onClick={handleDescriptionConfirm}
            disabled={loading}
          ></button>
        </div>
      )}
    </div>
  );
};

export default AddFlow;
